<div class="container">
  <mat-card class="tasks-card">
    <mat-card-content>
      <nav mat-tab-nav-bar class="navigation-tabs" [tabPanel]="tabPanel">
        <a
          mat-tab-link
          [routerLink]="['./checker-inbox']"
          routerLinkActive
          #checkerInbox="routerLinkActive"
          [active]="checkerInbox.isActive"
          *LOSxHasPermission="'ALL_FUNCTIONS_READ'"
        >
          {{ 'labels.inputs.Checker Inbox' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['./client-approval']"
          routerLinkActive
          #clientApproval="routerLinkActive"
          [active]="clientApproval.isActive"
          *LOSxHasPermission="'READ_CLIENT'"
        >
          {{ 'labels.inputs.Client Approval' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['./loan-approval']"
          routerLinkActive
          #loanApproval="routerLinkActive"
          [active]="loanApproval.isActive"
          *LOSxHasPermission="'READ_LOAN'"
        >
          {{ 'labels.inputs.Loan Approval' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['./loan-disbursal']"
          routerLinkActive
          #loanDisbursal="routerLinkActive"
          [active]="loanDisbursal.isActive"
          *LOSxHasPermission="'READ_LOAN'"
        >
          {{ 'labels.inputs.Loan Disbursal' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['./reschedule-loan']"
          routerLinkActive
          #rescheduleLoan="routerLinkActive"
          [active]="rescheduleLoan.isActive"
          *LOSxHasPermission="'RESCHEDULE_LOAN'"
        >
          {{ 'labels.inputs.Reschedule Loan' | translate }}
        </a>
      </nav>

      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </mat-card-content>
  </mat-card>
</div>
